import {useState, useEffect, useCallback} from 'react';

import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import Dialog, {DialogProps} from '@mui/material/Dialog';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Iconify from 'src/components/iconify';
import {Upload} from 'src/components/upload';
import uuidv4 from 'src/utils/uuidv4';
import Checkbox from '@mui/material/Checkbox';

// ----------------------------------------------------------------------
interface FileToUpload {
  ids: string;
  fileData: string ;
  fileName: string;
  fileType: string ;
  fileError: string;
}
interface WrittenData {
  id: string;
  title: string;
  description: string;
  date: string;
  isFavorited: boolean;
  attachmentName?: FileToUpload[];
}
interface Props extends DialogProps {
  title?: string;
  //
  // eslint-disable-next-line react/boolean-prop-naming
  onCreate?: boolean;
  //
  folderName?: WrittenData;
  onChangeFolderName?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  //
  // eslint-disable-next-line react/boolean-prop-naming
  open: boolean;
  onClose: VoidFunction;
  onSave?: (vals: WrittenData[]) => void; // Add your save logic here
  onEditSave?: (vals: WrittenData) => void; // Add your save logic here
}

export default function CardAddnotes({
  title = 'Upload Files',
  open,
  onClose,
  onCreate,
  folderName,
  onChangeFolderName,
  onSave,
  onEditSave,
  ...other
}: Props) {
  const [filesd, setFiles] = useState<(File | string)[]>([]);
  const [description, setDescription] = useState('');
  const [attachedFiles, setAttachedFiles] = useState<FileToUpload[]>([]);
  const [favorited, setIsFavorited] = useState(false);
  const [name, setname] = useState('');
  const [folderNameValue, setFolderNameValue] = useState(
    folderName?.title || ''
  );
  const [editdescription, setEditDescription] = useState(
    folderName?.description || ''
  );
  // const [editedattachedFiles, setEditedAttachedFiles] = useState<
  //   FileToUpload[]
  // >(folderName?.attachmentName || []);
  useEffect(() => {
    if (!open) {
      setFiles([]);
    }
  }, [open]);
  const currentDate = new Date();
  const monthNames = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
  ];
  const valuedate =
    currentDate.getDate() +
    ' ' +
    monthNames[currentDate.getMonth()] +
    ',' +
    currentDate.getFullYear() +
    ' ' +
    currentDate.getHours() +
    ':' +
    currentDate.getMinutes();
  const handleDrop = useCallback(
    (acceptedFiles: File[]) => {
      const newFiles = acceptedFiles.map(file =>
        Object.assign(file, {
          preview: URL.createObjectURL(file)
        })
      );

      setFiles([...filesd, ...newFiles]);
    },
    [filesd]
  );
  const generateUniqueId = () => {
    const values = uuidv4();
    // Implement a unique ID generation logic here
    return values;
  };
  const handleSave = () => {
    const fileToUpload: WrittenData[] = [];
    fileToUpload.push({
      id: generateUniqueId(),
      title: name,
      description: description,
      date: valuedate,
      isFavorited: favorited,
      attachmentName: attachedFiles
    });
    if (onSave) {
      onSave(fileToUpload);
    }
    onClose(); // Close the dialog after save
  };
  const handleEditSave = () => {
    const fileToUpload: WrittenData[] = []; // Initialize as an empty array of WrittenData objects
    fileToUpload.push({
      id: folderName?.id ?? '',
      title: folderNameValue,
      description: editdescription,
      date: folderName?.date ?? valuedate,
      isFavorited: favorited,
      attachmentName: folderName?.attachmentName ?? attachedFiles
    });
    if (onEditSave) {
      onEditSave(fileToUpload[0]);
    }
    onClose();
  }; // Close the dialog after save
  const handleFileUpload = () => {
    const files = filesd;
    if (!files) {
      return;
    }
    const fileToUpload: FileToUpload[] = []; // Prepare an array to hold file data for uploading
    Array.from(files).forEach((file, index) => {
      const reader = new FileReader();
      reader.onload = (loadEvent: ProgressEvent<FileReader>) => {
        if (typeof loadEvent.target?.result === 'string') {
          fileToUpload.push({
            ids: generateUniqueId(),
            fileData: loadEvent.target.result,
            fileName: typeof file === 'string' ? '' : (file as File).name,
            fileType: typeof file === 'string' ? '' : (file as File).type,
            fileError: ''
          });

          // Update state when all files are processed
          if (fileToUpload.length === files.length) {
            // Assuming `setFilesToUpload` is a new state setter you'll add
            setAttachedFiles(prevDetails => ({...prevDetails, ...fileToUpload}));
          }
        } else {
          console.error('FileReader did not return a string.');
        }
      };
      reader.readAsDataURL(
        file instanceof File ? file : new File([], '', {type: ''})
      );
    });
    console.info('ON UPLOAD');
  };

  const handleRemoveFile = (inputFile: File | string) => {
    const filtered = filesd.filter(file => file !== inputFile);
    setFiles(filtered);
  };

  const handleRemoveAllFiles = () => {
    setFiles([]);
  };
  const handlefavouritechanges = () => {
    setIsFavorited(!favorited);
  };

  return (
    <Dialog fullWidth maxWidth="sm" open={open} onClose={onClose} {...other}>
      <DialogTitle sx={{p: theme => theme.spacing(3, 3, 2, 3)}}>
        {onCreate ? (
          <Stack direction="row" alignItems="baseline" spacing={1} flexGrow={1}>
            <h3 style={{marginRight: '-0.5vh'}}> Add Note</h3>
            <h6>{valuedate}</h6>
          </Stack>
        ) : (
          <h3 style={{marginRight: '-0.5vh'}}> Edit Note</h3>
        )}

        <Stack
          direction="row"
          alignItems="center"
          sx={{
            top: 8,
            right: 8,
            position: 'absolute'
          }}>
          <Checkbox
            color="warning"
            icon={<Iconify icon="eva:star-outline" />}
            checkedIcon={<Iconify icon="eva:star-fill" />}
            checked={favorited}
            onChange={handlefavouritechanges}
          />

          <IconButton aria-label="close" onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Stack>
      </DialogTitle>

      <DialogContent dividers sx={{pt: 1, pb: 0, border: 'none'}}>
        {onCreate ? (
          <TextField
            fullWidth
            label="Title"
            value={name}
            onChange={e => setname(e.target.value)}
            sx={{mb: 0.25}}
          />
        ) : (
          <TextField
            fullWidth
            label="Title"
            value={folderNameValue}
            onChange={e => setFolderNameValue(e.target.value)}
            sx={{mb: 0.25}}
          />
        )}
        {onCreate ? (
          <TextField
            margin="dense"
            id="description"
            label="Description"
            type="text"
            fullWidth
            multiline
            rows={4}
            value={description}
            sx={{mb: 1}}
            onChange={e => setDescription(e.target.value)}
          />
        ) : (
          <TextField
            margin="dense"
            id="description"
            label="Description"
            type="text"
            fullWidth
            multiline
            rows={4}
            value={editdescription}
            sx={{mb: 1}}
            onChange={e => setEditDescription(e.target.value)}
          />
        )}

        <Upload
          multiple
          files={filesd}
          onDrop={handleDrop}
          onRemove={handleRemoveFile}
        />
      </DialogContent>

      <DialogActions>
        <Button
          variant="contained"
          startIcon={<Iconify icon="eva:cloud-upload-fill" />}
          onClick={handleFileUpload}>
          Upload
        </Button>

        {!!filesd.length && (
          <Button
            variant="outlined"
            color="inherit"
            onClick={handleRemoveAllFiles}>
            Remove all
          </Button>
        )}
        <Stack direction="row" justifyContent="flex-end" flexGrow={1}>
          {onCreate ? (
            <Button variant="soft" onClick={handleSave}>
              {'Save'}
            </Button>
          ) : (
            <Button variant="soft" onClick={handleEditSave}>
              {'Save'}
            </Button>
          )}
        </Stack>
      </DialogActions>
    </Dialog>
  );
}
